<template>
  <div class="col-sm-12">
    <div class="card report-page">
      <div class="dropdown-container">
              <div class="dropdown-item">
                <label for="fromDate">From Date</label>
                <input
                  type="date"
                  v-model="filters.fromDate"
                  class="search-input"
                  :max="filters.toDate"
                />
              </div>
              <div class="dropdown-item">
                <label for="toDate">To Date</label>
                <input
                  type="date"
                  v-model="filters.toDate"
                  class="search-input"
                  :min="filters.fromDate"
                />
              </div>
              <div class="dropdown-item">
                <label for="distributor">Distributor</label>
                <select v-model="filters.distributor" id="distributor" class="search-input">
                  <option value="">All</option>
                  <option
                    v-for="dist in distributors"
                    :key="dist.profile_id"
                    :value="dist.profile_id"
                  >
                    {{ dist.name }}
                  </option>
                </select>
              </div>
              
              <div class="search-container single">
                <button type="button" class="btn button-default" :disabled="loading" @click="search">
                  <i v-if="loading" class="fa fa-spinner fa-spin me-1"></i>
                  {{ loading ? "Searching..." : "Search" }}
                </button>
              </div>
            </div>

            <!-- Error Message -->
            <div v-if="errorMessage" class="no-data-message">
              <img src="../../../assets/vectors/data_not_found.png" alt="No Invoices" class="not-found-image" />
              <p class="text-center not-found-message">{{ errorMessage }}</p>
            </div>

            <div v-if="reportData.length > 0" class="tiles-container mt-3">
              <div class="tile tile-sales">
                <h5>Ordered</h5>
                <p>Qty: {{ totals.ordered.qty || 0 }}</p>
                <p>Value: {{ totals.ordered.value || 0 }}</p>
                <p>Volume: {{ totals.ordered.volume || 0 }}</p>
              </div>
              <div class="tile tile-delivered">
                <h5>Delivered</h5>
                <p>Qty: {{ totals.delivered.qty || 0 }}</p>
                <p>Value: {{ totals.delivered.value || 0 }}</p>
                <p>Volume: {{ totals.delivered.volume || 0 }}</p>
              </div>
              <div class="tile tile-loss">
                <h5>Loss</h5>
                <p>Qty: {{ totals.loss.qty || 0 }}</p>
                <p>Value: {{ totals.loss.value || 0 }}</p>
                <p>Volume: {{ totals.loss.volume || 0 }}</p>
              </div>
      </div>

      <div v-if="loading" class="loading-spinner mt-3">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div v-if="reportData.length > 0" class="mt-4">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="border-bottom-primary">
                <th>Item</th>
                <th>Ordered</th>
                <th>Delivered</th>
                <th>Loss</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in reportData" :key="item.item_name">
                <td>{{ item.item_name }}</td>
                <td>
                  Qty: {{ item.ordered.qty }}<br />
                  Value: {{ item.ordered.value }}<br />
                  Volume: {{ item.ordered.volume }}
                </td>
                <td>
                  Qty: {{ item.delivered.qty }}<br />
                  Value: {{ item.delivered.value }}<br />
                  Volume: {{ item.delivered.volume }}
                </td>
                <td>
                  Qty: {{ item.loss.qty }}<br />
                  Value: {{ item.loss.value }}<br />
                  Volume: {{ item.loss.volume }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchReportLossSale, fetchDistributorListOrderRequestAll } from '@/services/dataService';

export default {
  data() {
    const currentDate = new Date().toLocaleDateString('en-CA'); // 'en-CA' format gives YYYY-MM-DD
    return {
      filters: {
        fromDate: currentDate,
        toDate: currentDate,
        distributor: "",
      },
      distributors: [],
      reportData: [],
      totals: { ordered: {}, delivered: {}, loss: {} },
      loading: false,
      errorMessage: "", // New property for error message
    };
  },
  created() {
    this.loadDistributors();
  },
  methods: {
    async loadDistributors() {
      try {
        const token = localStorage.getItem("token_set");
        const response = await fetchDistributorListOrderRequestAll(token);
        this.distributors = response.data.data;
      } catch (error) {
        console.error("Error fetching distributors:", error);
      }
    },
    async search() {
      this.loading = true;
      this.errorMessage = ""; // Clear previous errors

      const params = {
        distributor_id: this.filters.distributor,
        from_date: this.filters.fromDate,
        to_date: this.filters.toDate
      };

      try {
        const token = localStorage.getItem("token_set");
        const response = await fetchReportLossSale(params, token);
        const { data, totals } = response.data;

        if (!data.length || !totals || Object.keys(totals).length === 0) {
          this.errorMessage = "Results not found!";
          this.reportData = [];
          this.totals = { ordered: {}, delivered: {}, loss: {} };
        } else {
          this.reportData = data;
          this.totals = totals;
        }
      } catch (error) {
        console.error("Error fetching report:", error);
        this.errorMessage = "An error occurred while fetching the report. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.quantity-input {
  width: 100px; /* Adjust the width as needed */
}
/* Styling for labels */
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px; /* Adjust font size for better readability */
}

/* Styling for select elements */
select {
  width: 100%; /* Ensure select takes full width of its container */
  padding: 15px; /* Increase padding for better spacing */
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  text-align: left; /* Left align the text */
  transition: border-color 0.3s, box-shadow 0.3s;
}
/* Focus styling for select elements */
select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

/* Styling for search input */
.search-input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

/* Focus styling for search input */
.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none; /* Remove the default outline */
}

/* Styling for search button */
.search-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn.button-default {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #ffffff;
  font-size: 14px; /* Adjust font size for better readability */
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.btn.button-default:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.btn.button-default:active {
  transform: scale(0.95);
}

/* Table styling */
.table-container {
  width: 100%;
  margin-top: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.table td {
  background-color: #ffffff;
}

/* Popup styling */
.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  list-style: none;
  padding: 0;
}

.popup-content li {
  margin-bottom: 10px;
}

.popup-content hr {
  border: 0;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

/* Optional: Add spacing and icon styling for the complaint messages */
.table td i.fa-flag {
  margin-right: 8px; /* Space between icon and text */
  color: red; /* Color of the flag icon */
}

/* Styling for the "eye" icon */
.fa-trash {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s; /* Smooth transition for color and transform */
}

/* Hover effect for the "eye" icon */
.fa-trash:hover {
  color: #ee164d; /* Darker shade on hover */
  transform: scale(1.2); /* Slightly enlarge the icon on hover */
}

/* Active effect for the "eye" icon */
.fa-trash:active {
  transform: scale(1.1); /* Slightly shrink the icon on click */
}

/* Status color classes */

.status-pending {
  background-color: #FFC107; /* Yellow color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-completed {
  background-color: #069E27; /* Green color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-scheduled {
  background-color: #1B6CB4; /* Blue color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

/* Loading spinner styles */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff; /* Preserved color for spinner */
}

/* New styles for the remark section */
.remark-section {
  margin-top: 20px;
}

.remark-section label {
  font-weight: bold;
  font-size: 14px;
}

.remark-section textarea {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.remark-section textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.remark-section textarea {
  width: 100%;
  padding: 10px 20px; /* Add padding to the right and left */
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}


.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  margin-left: 5px;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-edit:active {
  transform: scale(1.1);
}



/* Popup modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 800px;
  max-width: 100%;
  max-height: 80vh; /* Set a maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  transition: color 0.3s;
}

.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  padding-left: 20px;
}

.popup-content ul li {
  margin-bottom: 10px;
}

.popup-table {
  max-height: 300px; /* Adjust the height as needed */
  overflow-y: auto;  /* Enable vertical scrolling */
}


/* Tiles container */
.tiles-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 20px;
}

/* Tile styling */
.tile {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px; /* Reduced padding */
  text-align: center;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  flex: 1;
  margin: 0 5px; /* Reduced margin */
  max-width: 160px; /* Reduced max-width */
  position: relative;
  transition: transform 0.3s, box-shadow 0.3s;
}

.tile:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.tile-header {
  display: flex;
  justify-content: center; /* Center the content horizontally */
  align-items: center; /* Center the content vertically */
  flex-direction: column; /* Stack the title and icon vertically */
}

.tile h5 {
  margin: 0;
  font-size: 18px;
  color: #333;
  text-align: center; /* Center the text */
}

.tile-span-total {
  display: block;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #154422;
}

.tile-span {
  display: block;
  margin-top: 10px;
  font-size: 24px;
  font-weight: bold;
  color: #e90707;
}

.tile-span1 {
  display: block;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #0a131e;
}

.tile-sales {
  background-color: #e0f7e0; /* Light green */
}

.tile-delivered {
  background-color: #cce5ff; /* Light blue */
}

.tile-loss {
  background-color: #ffcccc; /* Light red */
}

.no-data-message {
  text-align: center;
  font-size: 12px;
  color: #888;
}

/* Results not found image */
.not-found-image {
  max-width: 250px;
}

/* Results not found message */
.not-found-message {
  font-size: 25px;
  font-weight: bold;
  color: #ccc;
  margin-top: -25px;
}
</style>